import { useContext } from 'react';

import { ChartToolbarContext } from '../context/ChartToolbar.context.js';

export const useToolbarContext = () => useContext(ChartToolbarContext);
